import { Sites } from '@ps/platform-message-framework/common/Sites';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

const useIsCARestrictedState = () => {
  const {
    values: { country, state },
    error
  } = useWizardContext();
  const siteId = useSelector(select.cms.getSiteId);
  const isCOM = siteId === Sites.COM;

  const { code } = error?.fieldErrors?.find(({ fieldName }) => fieldName === 'state') || {};
  return isCOM && country === Country.Canada && state !== 'ON' && code === 'restrictedState';
};

export default useIsCARestrictedState;
